import React from 'react';
import OrderRow from './OrderRow';
import OrderItemsOrderRowReceptionPoint from './OrderRowReceptionPoint';
import { connect } from 'react-redux';
import * as fetchingState from '../../constants/fetchingState';
import { getSettings as getSettingsAction } from '../../actions/settings';
import { delivery as deliverySettingsType } from '../../constants/settingTypes';
import * as permissions from '../../constants/permissions';

export const TableHeader = ({ orders, children }) => {

    if (!orders || orders.length === 0)
        return <span>Пусто</span>;

    return (<table className="table table-hover">
        <thead>
            <tr>
                <td></td>
                <td>Номер заявки</td>
                <td>Дата создания</td>
                <td>Телефон</td>
                <td>Статус</td>
                <td>Адрес</td>
                <td>Когда забрать</td>
                <td>Когда привезти</td>
                <td></td>
            </tr>
        </thead>
        {children}
    </table>);
}

export const TableHeaderReceptionPoint = ({ orders, children }) => {

    if (!orders || orders.length === 0)
        return <span>Пусто</span>;

    return (<table className="table table-hover">
        <thead>
            <tr>
                <td></td>
                <td>Номер заявки</td>
                <td>Телефон</td>
                <td>Статус</td>
                <td>Адрес</td>
                <td>Дата создания</td>
                <td>Когда будет готов</td>
                <td>Когда отдан</td>
                <td></td>
            </tr>
        </thead>
        {children}
    </table>);
}


let OrdersTable = class extends React.Component {
    _editClick(service) {
        this.props.editClick(service);
    }
    componentDidMount() {
        this.props.getSettingsAction(deliverySettingsType);
    }

    render() {
        const { entities: orders, delivery } = this.props;
        if (delivery.fetching !== fetchingState.FETCHED)
            return null;
        if(permissions.getRole() == permissions.RECEPTION_POINT)
        {
            return <TableHeaderReceptionPoint orders={orders}>
            {orders && orders.map(o => {
                const onEditClick = this._editClick.bind(this, o);
                return (
                    <OrderItemsOrderRowReceptionPoint
                        order={o}
                        onEditClick={onEditClick}
                        key={o.Id}
                        delivery={delivery.data} />);
            })}
        </TableHeaderReceptionPoint>

        }
        return <TableHeader orders={orders}>
            {orders && orders.map(o => {
                const onEditClick = this._editClick.bind(this, o);
                return (
                    <OrderRow
                        order={o}
                        onEditClick={onEditClick}
                        key={o.Id}
                        delivery={delivery.data} />);
            })}
        </TableHeader>
    }
}

export default connect(state => ({ delivery: state.application.get('settings').delivery }), { getSettingsAction })(OrdersTable);


// WEBPACK FOOTER //
// ./src/components/orders/OrdersTable.jsx